import script from "./WorkspaceSites.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSites.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceSites.vue?vue&type=style&index=0&id=010a83d7&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010a83d7"]])

export default __exports__